import { PaintedScene } from '../PaintedScene';

export const HILL_PATH_WEST_PHASER_KEY = 'HillPathWestScene' as const;
export const HILL_PATH_WEST_MANIFEST_KEY = 's-501-hill-path-west' as const;

export class HillPathWestScene extends PaintedScene {
  constructor() {
    super(HILL_PATH_WEST_PHASER_KEY, HILL_PATH_WEST_MANIFEST_KEY);
  }
}
